module.exports = __webpack_public_path__ + "static/media/draw.4fda3ec2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/draw.gif
// module id = 56
// module chunks = 0